import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { USFBuildingCalculations } from 'spw-components/programming-scenarios/building-hs-sc-scenario/USF-building-calculations';
import { selectProgramSummaryCalculator } from 'spw-redux/modules/calculators/selectors';
import { IAppState } from 'spw-redux/reducer';
import {
  useScenarioOrTotalProgramExportable,
  useVariantsOverride,
  useWorksheet,
} from 'spw-programming-projects/downloads/exportables/hooks';
import { isDepartmentScenario } from 'spw-components/worksheet/utils';
import { isNil } from 'ramda';

const ProgramSummaryCalculationsExportable: React.FunctionComponent = () => {
  const {
    isTotalProgram,
    currentScenario,
    currentProject,
    projectSpaceTypes,
    departments,
    currentBuilding,
  } = useScenarioOrTotalProgramExportable();
  const { showDecimals } = useVariantsOverride();

  const programSummaryCalculator = useSelector((state: IAppState) =>
    selectProgramSummaryCalculator(state)
  );

  const { worksheet } = useWorksheet(isTotalProgram);

  const shouldRender = useMemo(() => {
    let isAllDataAvailable = isTotalProgram
      ? Boolean(
          currentScenario?.id &&
            !isNil(worksheet) &&
            projectSpaceTypes.length > 0 &&
            !isNil(programSummaryCalculator)
        )
      : Boolean(
          currentScenario?.id &&
            worksheet?.id &&
            currentProject?.id &&
            projectSpaceTypes?.length &&
            !isNil(programSummaryCalculator)
        );

    if (isDepartmentScenario(currentScenario)) {
      isAllDataAvailable = Boolean(isAllDataAvailable && departments?.length);
    }

    return isAllDataAvailable;
  }, [
    isTotalProgram,
    currentScenario,
    worksheet,
    currentProject,
    projectSpaceTypes,
    departments,
    programSummaryCalculator,
  ]);

  return shouldRender ? (
    <div className="content">
      <USFBuildingCalculations
        scenario={currentScenario}
        programSummaryCalculator={programSummaryCalculator}
        building={currentBuilding}
        inBrowserDownload
        initialShowDecimals={showDecimals}
      />
    </div>
  ) : null;
};

export default ProgramSummaryCalculationsExportable;
